<span
  #triggerRef
  (blur)="onBlur()"
  (click)="onTriggerClick($event)"
  (focus)="onFocus()"
  (keydown)="onTriggerKeydown($event)"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  [attr.aria-expanded]="isOpen"
  [attr.aria-label]="ariaLabel"
  [attr.dir]="rtl ? 'rtl' : null"
  class="info-hint__trigger"
  role="button"
  tabindex="0"
>
  <img
    *ngIf="iconSrc; else defaultIcon"
    [src]="iconSrc"
    alt=""
    class="info-hint__icon-image"
  >
  <ng-template #defaultIcon>
    <svg
      aria-hidden="true"
      class="info-hint__icon-svg"
      fill="none"
      focusable="false"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.87589 3.79143C7.87589 4.02349 7.7837 4.24605 7.61961 4.41015C7.45551 4.57424 7.23295 4.66643 7.00089 4.66643C6.76882 4.66643 6.54626 4.57424 6.38217 4.41015C6.21807 4.24605 6.12589 4.02349 6.12589 3.79143C6.12589 3.55936 6.21807 3.3368 6.38217 3.17271C6.54626 3.00861 6.76882 2.91643 7.00089 2.91643C7.23295 2.91643 7.45551 3.00861 7.61961 3.17271C7.7837 3.3368 7.87589 3.55936 7.87589 3.79143ZM14.0009 11.0831V7.19809C14.0226 5.39994 13.3634 3.66012 12.1554 2.32794C10.9475 0.995772 9.28025 0.169882 7.48855 0.0160937C6.48852 -0.0538726 5.48511 0.0917752 4.54624 0.443183C3.60737 0.79459 2.75492 1.34356 2.04659 2.05295C1.33825 2.76233 0.790545 3.61559 0.440529 4.55498C0.0905136 5.49438 -0.0536466 6.49799 0.0178022 7.49793C0.275636 11.2044 3.54872 13.9998 7.63264 13.9998H11.0842C11.8575 13.9988 12.5988 13.6912 13.1456 13.1445C13.6924 12.5977 14 11.8564 14.0009 11.0831ZM7.40922 1.18043C8.90632 1.31287 10.2978 2.00696 11.3042 3.12325C12.3105 4.23954 12.8572 5.69532 12.8342 7.19809V11.0831C12.8342 11.5472 12.6498 11.9923 12.3217 12.3205C11.9935 12.6487 11.5483 12.8331 11.0842 12.8331H7.63264C4.1128 12.8331 1.40089 10.5581 1.18214 7.41743C1.12471 6.61743 1.23287 5.81419 1.49987 5.05788C1.76686 4.30158 2.18696 3.60845 2.7339 3.02182C3.28085 2.43518 3.94289 1.96764 4.67868 1.6484C5.41446 1.32917 6.20817 1.16509 7.01022 1.16643C7.14264 1.16643 7.27622 1.17168 7.40922 1.18043ZM8.16755 10.4998V6.99976C8.16755 6.69034 8.04464 6.3936 7.82584 6.1748C7.60705 5.95601 7.31031 5.83309 7.00089 5.83309H6.41755C6.26284 5.83309 6.11447 5.89455 6.00507 6.00395C5.89568 6.11335 5.83422 6.26172 5.83422 6.41643C5.83422 6.57114 5.89568 6.71951 6.00507 6.82891C6.11447 6.9383 6.26284 6.99976 6.41755 6.99976H7.00089V10.4998C7.00089 10.6545 7.06235 10.8028 7.17174 10.9122C7.28114 11.0216 7.42951 11.0831 7.58422 11.0831C7.73893 11.0831 7.8873 11.0216 7.9967 10.9122C8.1061 10.8028 8.16755 10.6545 8.16755 10.4998Z"
        fill="#92A0C0"
      ></path>
    </svg>
  </ng-template>
</span>

<div
  #panelRef
  (mouseenter)="onPanelMouseEnter()"
  (mouseleave)="onPanelMouseLeave()"
  [attr.dir]="rtl ? 'rtl' : null"
  [class.info-hint__panel--open]="isOpen"
  [ngClass]="'info-hint__panel--' + position"
  [style.left.px]="panelLeft"
  [style.top.px]="panelTop"
  class="info-hint__panel"
  role="tooltip"
>
  <span
    [ngClass]="'info-hint__arrow--' + position"
    [style.left]="position === 'top' || position === 'bottom' ? arrowLeftCss : null"
    [style.top]="position === 'left' || position === 'right' ? arrowTopCss : null"
    class="info-hint__arrow"
  ></span>

  <button
    (click)="close()"
    *ngIf="isTouchMode"
    [attr.aria-label]="'Close tooltip'"
    class="info-hint__close"
    type="button"
  >
    <span class="info-hint__close-line info-hint__close-line--first"></span>
    <span class="info-hint__close-line info-hint__close-line--second"></span>
  </button>

  <ng-container *ngIf="contentTemplate; else plainTextContent">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ng-container>

  <ng-template #plainTextContent>
    {{ text }}
  </ng-template>
</div>
